export enum CsatType {
	LPA = "lpa",
	ACP = "acp",
	ACP_NHS = "acp_nhs",
	ACP_WITHOUT_NHS = "acp_without_nhs",
	LPA_ACP = "lpa_acp",
	DEATH_CERTIFICATE = "death_certificate",
}
